import React from "react";
import TopNav from "../../bars/TopNav";
import Footer from "../../bars/Footer";

function Terms() {
  return (
    <div>
      <TopNav />

      <div className="top_section w-full mt-24 mb-10">
        <h2>Terms & Conditions</h2>
        <p><br />
          Last updated: July 01, 2023 <br /><br />
          These Terms and Conditions ("Terms", "Terms and Conditions") govern
          your relationship with https://inaipi.ai website (the
          "Service") operated by Inaipi Private Limited ("us", "we", or "our"). Please
          read these Terms and Conditions carefully before using the Service.
          Your access to and use of the Service is conditioned on your
          acceptance of and compliance with these Terms. These Terms apply to
          all visitors, users and others who access or use the Service.By
          accessing or using the Service you agree to be bound by these Terms.
          If you disagree with any part of the terms then you may not access the
          Service.
        </p>
        <h3 className="mt-5">Purchases</h3>
        <p>
          If you wish to purchase any product or service made available through
          the Service ("Purchase"), you may be asked to supply certain
          information relevant to your Purchase including, without limitation,
          your Credit card number, the expiration date of your Credit card, your
          billing address, and your shipping information.<br/><br/> You represent and
          warrant that : (i) you have the legal right to use any Credit card(s)
          or other payment method(s) in connection with any Purchase; and that
          (ii) the information you supply to us is true, correct and complete.
         <br/><br/> By submitting such information, you grant us the right to provide the
          information to third parties for purposes of facilitating the
          completion of Purchases.<br/><br/> We reserve the right to refuse or cancel your
          order at any time for certain reasons including but not limited to:
          product or service availability, errors in the description or price of
          the product or service, error in your order or other reasons.<br/><br/> We
          reserve the right to refuse or cancel your order if fraud or an
          unauthorized or illegal transaction is suspected.
        </p>
        <h3 className="mt-5">Availability, Errors & Inaccuracies</h3>
        <p>
          We are constantly updating our offerings of products and services on
          the Service. The products or services available on our Service may be
          misprized, described inaccurately, or unavailable, and we may
          experience delays in updating information on the Service and in our
          advertising on other web sites.<br/><br/> We cannot and do not guarantee the
          accuracy or completeness of any information, including prices, product
          images, specifications, availability, and services. We reserve the
          right to change or update information and to correct errors,
          inaccuracies, or omissions at any time without prior notice.
        </p>
        <h3 className="mt-5">Content</h3>
        <p>
          Our Service allows you to post, link, store, share and otherwise make
          available certain information, text, graphics, videos, or other
          material ("Content"). You are responsible for the Content that you
          post to the Service, including its legality, reliability, and
          appropriateness. <br/><br/>By posting Content to the Service, you grant us the
          right and license to use, modify, publicly perform, publicly display,
          reproduce, and distribute such Content on and through the Service. You
          retain any and all of your rights to any Content you submit, post or
          display on or through the Service and you are responsible for
          protecting those rights. You agree that this license includes the
          right for us to make your Content available to other users of the
          Service, who may also use your Content subject to these Terms.<br/><br/> You
          represent and warrant that: (i) the Content is yours (you own it) or
          you have the right to use it and grant us the rights and license as
          provided in these Terms, and (ii) the posting of your Content on or
          through the Service does not violate the privacy rights, publicity
          rights, copyrights, contract rights or any other rights of any person.
        </p>
        <h3 className="mt-5">Accounts</h3>
        <p>
          When you create an account with us, you must provide us information
          that is accurate, complete, and current at all times. Failure to do so
          constitutes a breach of the Terms, which may result in immediate
          termination of your account on our Service.<br/><br/> You are responsible for
          safeguarding the password that you use to access the Service and for
          any activities or actions under your password, whether your password
          is with our Service or a third-party service. <br/><br/>You agree not to
          disclose your password to any third party. You must notify us
          immediately upon becoming aware of any breach of security or
          unauthorized use of your account. <br/><br/>You may not use as a username the
          name of another person or entity or that is not lawfully available for
          use, a name or trade mark that is subject to any rights of another
          person or entity other than you without appropriate authorization, or
          a name that is otherwise offensive, vulgar or obscene.
        </p>
        <h3 className="mt-5">Intellectual Property</h3>
        <p>
          The Service and its original content (excluding Content provided by
          users), features and functionality are and will remain the exclusive
          property of Inaipi Private Limited and its licensors. The Service is
          protected by copyright, trademark, and other laws of India. Our trademarks and trade dress may not
          be used in connection with any product or service without the prior
          written consent of Inaipi Private Limited.
        </p>
        <h3 className="mt-5">Links to Other websites</h3>
        <p>
          Our Service may contain links to third-party web sites or services
          that are not owned or controlled by Inaipi Private Limited. <br/><br/>Inaipi Private Limited
          has no control over, and assumes no responsibility for, the content,
          privacy policies, or practices of any third party web sites or
          services. You further acknowledge and agree that Inaipi Private Limited shall
          not be responsible or liable, directly or indirectly, for any damage
          or loss caused or alleged to be caused by or in connection with use of
          or reliance on any such content, goods or services available on or
          through any such web sites or services. <br/><br/>We strongly advise you to read
          the terms and conditions and privacy policies of any third-party web
          sites or services that you visit.
        </p>
        <h3 className="mt-5">Termination</h3>
        <p>
          We may terminate or suspend your account immediately, without prior
          notice or liability, for any reason whatsoever, including without
          limitation if you breach the Terms.<br/> Upon termination, your right to
          use the Service will immediately cease. If you wish to terminate your
          account, you may simply discontinue using the Service.
        </p>
        <h3 className="mt-5">Governing Law</h3>
        <p>
          These Terms shall be governed and construed in accordance with the
          laws of India, without regard to its conflict of law
          provisions. <br/><br/>Our failure to enforce any right or provision of these
          Terms will not be considered a waiver of those rights. If any
          provision of these Terms is held to be invalid or unenforceable by a
          court, the remaining provisions of these Terms will remain in effect.
          These Terms constitute the entire agreement between us regarding our
          Service, and supersede and replace any prior agreements we might have
          between us regarding the Service.
        </p>
        <h3 className="mt-5">Changes</h3>
        <p>
          We reserve the right, at our sole discretion, to modify or replace
          these Terms at any time. If a revision is material we will try to
          provide at least 30 days notice prior to any new terms taking effect.
          What constitutes a material change will be determined at our sole
          discretion.<br/><br/> By continuing to access or use our Service after those
          revisions become effective, you agree to be bound by the revised
          terms. If you do not agree to the new terms, please stop using the
          Service.
        </p>
        <h3 className="mt-5">Contact Us</h3>
        <p>
          If you have any questions about these Terms, please contact us-
         aisupport@inaipi.ai
        </p>
      </div>
      <Footer />
    </div>
  );
}

export default Terms;
